<div [ngClass]="getLevelClass()">
  <div class="form__label">
    <basic-label></basic-label>
  </div>

  <div class="col-xs-24 col-sm-15">
    <textarea
      [(ngModel)]="inputText"
      (change)="trigger()"
      (blur)="handleBlur()"
      [disabled]="isDisabled"
      class="input fill"
      maxlength="250"
      type="text"
    ></textarea>
  </div>
  <p class="error-message" *ngIf="isError()">
    {{ errorMessage[prop] }}
  </p>
</div>
